import Component from '@averyano/core/src/classes/Component';
import each from 'lodash/each';
import Form from '../../components/form';
import axios from 'axios';
import GSAP from 'gsap';

export default class ContactForm extends Component {
	constructor(el) {
		super({
			element: '.contact__form',
			elements: {
				singlelines: '.contact__form-input',
				textareas: '.contact__form-textarea',
			},
		});
		this.id = 'contact';
	}

	create() {
		console.log('FN_URL.submitForm', FN_URL.submitForm);
		super.createComponent();
		this.components = {
			form: new Form({
				url: FN_URL.submitForm,
			}),
		};
		this.isCreated = true;
		// }

		this.addEventListeners(); // @TODO DOUBLE CHECK
		// Create Components
		each(this.components, (component) => {
			component.create();
		});
		console.log(`🔼 ${this.id} is created`);
	}

	submitForm() {
		this.components.form.requestSubmitForm();
	}

	updateUi() {}

	show() {}

	hide() {
		return new Promise((resolve) => {
			this.destroy();

			GSAP.to(this.element, {
				autoAlpha: 0,
				onComplete: resolve,
			});
		});
	}

	async addEventListeners() {
		console.log('adddddď');
		each(this.components, (component) => {
			if (component.addEventListeners) component.addEventListeners();
		});

		each(this.elements.singlelines, (element) => {
			element.addEventListener('input', () => {
				if (element.value.length > 0) {
					element.classList.add('contact__form-input--filled');
				} else {
					element.classList.remove('contact__form-input--filled');
				}
			});
		});
		each(this.elements.textareas, (element) => {
			element.addEventListener('input', () => {
				if (element.value.length > 0) {
					element.classList.add('contact__form-textarea--filled');
				} else {
					element.classList.remove('contact__form-textarea--filled');
				}
			});
		});
	}

	removeEventListeners() {
		each(this.components, (component) => {
			component.removeEventListeners();
		});

		each(this.elements.singlelines, (element) => {
			element.removeEventListener('input', () => {
				if (element.value.length > 0) {
					element.classList.add('contact__form-input--filled');
				} else {
					element.classList.remove('contact__form-input--filled');
				}
			});
		});

		each(this.elements.textareas, (element) => {
			element.removeEventListener('input', () => {
				if (element.value.length > 0) {
					element.classList.add('contact__form-textarea--filled');
				} else {
					element.classList.remove('contact__form-textarea--filled');
				}
			});
		});
	}

	destroy() {
		super.destroy();
		this.removeEventListeners();

		each(this.components, (component) => {
			component.destroy();
		});
	}

	onResize() {
		each(this.components, (component) => {
			if (component.onResize) component.onResize();
		});
	}
}
